import {
  EntityInterface,
  TableColCfg
} from '@core/models/entities/entity-visualization-interface';
import { EntityCfgOverrides } from '@core/models/entities/generic-entity-cfg';
import { CustomData } from '@core/models/entities/implementations/custom-data';
import { Quantity } from '@core/models/entities/implementations/quantified-expertise';
import { UserCompartmentV1Model } from '@core/models/entities/implementations/user-compartment-v1';
import {
  UserEntityRegistrations,
  renderRegistrations
} from '@core/models/entities/implementations/user-entity-registrations';
import { EntityLabelsTranslationService } from '@core/services/entity-labels-translation/entity-labels-translation.service';
import { GenericEntityRegistryService } from '@core/services/user-models-registry/generic-entity-registry.service';

export type UserLoadingKind = 'Rear' | 'RightSide' | 'LeftSide';

export interface UserTrailerV1Model {
  uid: string;
  holding_quantities: Quantity[]; // Default empty array in Rust
  compartments?: UserCompartmentV1Model[];
  compatible_temperature_uids?: string[]; // None means no restriction in Rust
  equipment_uids?: string[];
  is_detachable: boolean; // Default false in Rust
  loading_direction?: UserLoadingKind; // None means no restriction in Rust
  is_pre_loaded: boolean; // Default false in Rust
  company_uid?: string;
  registrations?: UserEntityRegistrations;
  custom_data: CustomData;
}

export function registerTrailerExtensions(registry: GenericEntityRegistryService): void {
  const overrides: EntityCfgOverrides<UserTrailerV1Model> = {
    buildColumns: (
      autoColumns: TableColCfg<EntityInterface<UserTrailerV1Model>>[]
    ): TableColCfg<EntityInterface<UserTrailerV1Model>>[] =>
      autoColumns.map((col) => {
        const key = col.key as string;
        if (key === 'raw.registrations') {
          return {
            ...col,
            renderHook: (value: unknown) =>
              value == null ? '' : renderRegistrations(value as UserEntityRegistrations)
          };
        }
        if (key === 'raw.loading_direction') {
          return {
            ...col,
            type: 'enum' as const,
            renderHook: (value: unknown) => {
              if (value == null) return '';
              return EntityLabelsTranslationService.translateLabelStatic(
                `table.enum.loading_direction.${value as string}`
              );
            }
          };
        }
        return col;
      })
  };
  registry.registerOverrides<UserTrailerV1Model>('UserTrailer', overrides);
}
